import { render, staticRenderFns } from "./search-error.vue?vue&type=template&id=624249d2&scoped=true"
import script from "./search-error.vue?vue&type=script&lang=js"
export * from "./search-error.vue?vue&type=script&lang=js"
import style0 from "./search-error.vue?vue&type=style&index=0&id=624249d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624249d2",
  null
  
)

export default component.exports